module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-60.aec9f3a.woff2";